export default __webpack_public_path__ + "static/media/image-community-1.b030fe1f.png";